module.exports = __webpack_public_path__ + "static/arrow_right-4f4ac876da0eb5f0bb0da8676566b637.png";